module.exports = __webpack_public_path__ + "img/no-saved-job.3b280e89.svg";